import m from "mithril"
import { state } from "../state/store.js"

function setCategory(cat) {
  state.activeCategory = cat
}

function setYear(e) {
  state.activeYear = e.target.value
}

function toggleSort() {
  state.sortOrder = state.sortOrder === "desc" ? "asc" : "desc"
}

export default {
  view: function (vnode) {
    var count = vnode.attrs.count || 0

    var categories = (state.settings.filterCategories && Array.isArray(state.settings.filterCategories))
      ? state.settings.filterCategories
      : [
        { id: "branding", label: "Branding" },
        { id: "web", label: "Web Design" },
        { id: "illustration", label: "Illustration" },
        { id: "animation", label: "Animation" },
        { id: "print", label: "Print" },
      ]

    var years = (state.settings.yearFilter && Array.isArray(state.settings.yearFilter))
      ? state.settings.yearFilter
      : ["2026", "2025", "2024", "2023"]

    return m("section.filters", [
      m("div.filter-group", [
        m("div.filter-results1.text-left", [
          // m("span", count),
          // " projects",
        ]),
        // m("div.filter-categories", [
        //   m("button.filter-btn", {
        //     class: state.activeCategory === "all" ? "active" : "",
        //     onclick: function () { setCategory("all") },
        //   }, "All"),
        //   categories.map(function (cat) {
        //     return m("button.filter-btn", {
        //       key: cat.id,
        //       class: state.activeCategory === cat.id ? "active" : "",
        //       onclick: function () { setCategory(cat.id) },
        //     }, cat.label)
        //   }),
        // ]),
        m("div.filter-controls.float-right", [
          m("select.filter-select", {
            value: state.activeYear,
            onchange: setYear,
          }, [
            m("option", { value: "all" }, "All Years"),
            years.map(function (year) {
              return m("option", { key: year, value: year }, year)
            }),
          ]),
          m("button.sort-btn", {
            title: "Sort order",
            onclick: toggleSort,
          }, [
            state.sortOrder === "desc"
              ? m("svg", { width: 18, height: 18, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", "stroke-width": 2 },
                m("path", { d: "M12 5v14M5 12l7 7 7-7" }))
              : m("svg", { width: 18, height: 18, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", "stroke-width": 2 },
                m("path", { d: "M12 19V5M5 12l7-7 7 7" })),
            m("span", state.sortOrder === "desc" ? "Newest" : "Oldest"),
          ]),
        ]),
      ]),
      // m("div.filter-results", [
      //   m("span", count),
      //   " projects",
      // ]),
    ])
  },
}
